<template>
  <div>
    <modal-box
      :is-active="isModalActive"
      :trash-object-name="trashObjectName"
      @confirm="trashConfirm"
      @cancel="trashCancel"
    />

    <UpdateUserModal
      v-if="isEditModalActive"
      :isOpen="isEditModalActive"
      slot="button"
      class="level-item"
      @cancel="editCancel"
      :authUser="editObject"
    />
    <b-table
      :checkable="checkable"
      :loading="isLoading"
      paginated
      backend-pagination
      @page-change="onPageChange"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      backend-sorting
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      @sort="onSort"
      :total="totalUserItems"
      :per-page="perPage"
      :striped="true"
      :hoverable="true"
      :current-page="currentPage"
      :data="users"
      cell-class="cell-class"
    >
      <template slot-scope="props">
        <!-- <b-table-column class="has-no-head-mobile is-image-cell">
          <figure class="media-left">
            <div class="image-cropper">
              <img :src="props.row.photoUrl" alt="avatar" class="profile-pic" />
            </div>
          </figure>
        </b-table-column> -->
        <!-- <b-table-column label="ID" field="id">{{
          props.row._id
        }}</b-table-column>-->
        <b-table-column label="Role" field="role" class='beautify' sortable>
          {{
          props.row.role | roleIden
          }}
          </b-table-column>
        <b-table-column label="Name" field="name" sortable>
          {{
          props.row.name
          }}
          </b-table-column>
          <!-- <b-table-column label="Verified" field="verified" sortable>
          {{
          props.row.isUserVerified
          }}
          </b-table-column> -->
        <b-table-column label="Email" field="email" class='beautify' sortable>
          {{
          props.row.email
          }}
        </b-table-column>
        <b-table-column label="Code No."  sortable>
          {{
          props.row.code_no
          }}
        </b-table-column>
        <b-table-column label="Office Code No." class='beautify' sortable>
          {{
          props.row.office_code_no
          }}
        </b-table-column>
        <b-table-column label="Designation" sortable>
          {{
          props.row.designation
          }}
        </b-table-column>
        <b-table-column label="Contact Number" class='beautify' sortable>
          {{
          props.row.contact_number
          }}
        </b-table-column>
        <!-- <b-table-column label="Role" field="role">
          {{
          props.row.role
          }}
        </b-table-column> -->
        <b-table-column label="Created At" field="createdAt" sortable>
          {{
          props.row.createdAt | formatDate
          }}
        </b-table-column>

        <b-table-column
          v-if="props.row.lastLoggedIn"
          label="Last Signed In"
          field="createdAt"
          class='beautify'
          sortable
        >
          {{
          props.row.lastLoggedIn | fromNow
          }}
        </b-table-column>

        <b-table-column v-else label="Last Signed In" field="createdAt" sortable>N/A</b-table-column>

        <b-table-column custom-key="actions" class="is-actions-cell">
          <div class="buttons is-right">
            <button
              class="button is-small is-primary"
              type="button"
              @click.prevent="editModal(props.row)"
            >
              <b-icon pack="fas" icon="pencil-alt" custom-size="default" />
            </button>
            <button
              class="button is-small is-danger"
              type="button"
              @click.prevent="trashModal(props.row)"
            >
              <b-icon icon="trash-alt" custom-size="default" />
            </button>
          </div>
        </b-table-column>
      </template>

      <section class="section" slot="empty">
        <div class="content has-text-grey has-text-centered">
          <template v-if="isLoading">
            <p>
              <b-icon icon="dots-horizontal" size="is-large" />
            </p>
            <p>Fetching data...</p>
          </template>
          <template v-else>
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p>Nothing's there&hellip;</p>
          </template>
        </div>
      </section>
    </b-table>
  </div>
</template>

            
<script>
import axios from 'axios';
import ModalBox from './ModalBox';
import UpdateUserModal from './UpdateUserModal';

export default {
  name: 'ClientsTableSample',
  components: { ModalBox, UpdateUserModal },
  props: {
    dataUrl: {
      type: String,
      default: null,
    },
    checkable: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    roleIden: function (value) {
      if(value == 0){
        return 'Super Admin';
      } else if (value == 1){
          return 'Admin'
      } else if (value == 2){
          return 'Data Admin'
      } else if (value == 4){
          return 'Analytics'
      }
      else {
          return 'Data Clerk';
      }
    }
  },
  data() {
    return {
      isModalActive: false,
      isEditModalActive: false,
      trashObject: null,
      editObject: null,
      clients: [],
      isLoading: false,
      paginated: true,
      perPage: 10,
      currentPage: 1,
      totalItems: 60,
      sortField: 'name',
      sortOrder: '+',
      defaultSortOrder: '+',
    };
  },
  computed: {
    trashObjectName() {
      if (this.trashObject) {
        return this.trashObject;
      }

      return {};
    },
    users() {
      return this.$store.state.users.items;
    },
    totalUserItems() {
      return this.$store.state.users.total;
    },
  },
  methods: {
     getRole(val){
       if(val ==1){
         return 'Hello';
       } else {
         return 'GoodBye';
       }
     },
    fetchUser() {
      const sortBy = this.sortOrder + this.sortField;
      this.$store
        .dispatch('users/fetchUsers', {
          filter: {
            page: this.currentPage,
            limit: 10,
            sort: sortBy,
          },
        })
        .then(() => {
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          this.$buefy.toast.open({
            message: `Error: ${err.message}`,
            type: 'is-danger',
          });
        });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.fetchUser();
    },
    onSort(field, order) {
      // console.log(field, order);
      this.sortField = field;
      if (order === 'desc') {
        this.sortOrder = '-';
      } else {
        this.sortOrder = '+';
      }
      this.fetchUser();
      //   this.loadAsyncData();
    },
    trashModal(trashObject) {
      this.trashObject = trashObject;
      this.isModalActive = true;
    },
    editModal(editObject) {
      this.editObject = editObject;
      this.isEditModalActive = true;
    },
    trashConfirm() {
      this.$store
        .dispatch('users/deleteUserWithId', this.trashObject._id)
        .then(() => {
          this.isModalActive = false;
          this.$buefy.snackbar.open({
            message: 'User Deleted Successfully',
            queue: false,
          });
        })
        .catch((err) => {
          this.isModalActive = false;
          this.$buefy.snackbar.open({
            message: 'Failed to delete user',
            queue: false,
          });
        });
    },
    editConfirm() {
      console.log('Update Pressed');
    },
    trashCancel() {
      this.isModalActive = false;
    },
    editCancel() {
      this.isEditModalActive = false;
    },
  },
};
</script>

<style scoped>
/* .is-rounded {
  object-fit: cover;
  height: auto;
} */

.image-cropper {
  width: 50px;
  height: 50px;
  position: relative;
  overflow: hidden;
  border-radius: 50%;
}

.profile-pic {
  margin: 0 auto;
  object-fit: contain;
  width: 100%;
  height: 100%;
}

.cell-class {
  color: black;
}
.beautify {
  background-color: #F3F1F5;
}
</style>
